import { createStore, combineReducers, applyMiddleware } from 'redux';
import {applicationReducer} from '../reducers/ApplicationReducer';
import {formReducer} from '../reducers/FormReducer';
import {migrateReducer} from '../reducers/MigrateReducer';
import { iconReducer } from '../reducers/IconReducer';
import thunkMiddleware from 'redux-thunk';

// Create the store and combine the reducers
const store = createStore(
    combineReducers({
        app: applicationReducer,
        form: formReducer,
        migrate: migrateReducer,
        icon: iconReducer

    }),
    applyMiddleware(thunkMiddleware)
);

// Gets the created store so we don't expose the object itself
export const getStore = () => {
    return store;
};
